import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Box, Typography } from "@mui/material";
import { Courses, Projects } from "../Courses/developercourses";

const Start = () => {
  const [showContent, setShowContent] = useState("courses");

  const handleButtonClick = (contentType) => {
    setShowContent(contentType);
  };

  return (
    <div className="mylearningpaths">
      <Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 3, flexWrap: "wrap", margin:"20px 20px 26px 20px" }}>
          <Link to="/learners/dashboard/internetofthings" style={{ textDecoration: "none", marginLeft :"10px" }}>
            <Box
              component="button"
              sx={{
                px: 2,
                py: 1,
                fontSize: 14,
                fontWeight: 600,
                backgroundColor: "#fff",
                border: "1px solid #ccc",
                borderRadius: 2,
                color: "#052659",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "#e6f0ff",
                },
              }}
            >
              ← Back to Learning Path
            </Box>
          </Link>

          <Box>
            <Typography
              variant="h5"
              fontWeight={700}
              sx={{ color: "#052659", fontSize: { xs: "20px", sm: "20px", md: "20px" } }}
            >
              IoT Developer/Engineer
            </Typography>
            {/* <Typography
              variant="body2"
              sx={{ color: "#555", fontSize: { xs: "14px", sm: "15px" } }}
            >
              Master the fundamentals of IoT development and engineering
            </Typography> */}
          </Box>
        </Box>
        <Box sx={{ margin:"20px 30px" }}>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => handleButtonClick("courses")}
          sx={{
            backgroundColor: showContent === "courses" ? "rgb(27, 110, 244)" : "white",
            color: showContent === "courses" ? "white" : "black",
            border: "1px solid rgb(27, 110, 244)",
            '&:hover': {
              backgroundColor: showContent === "courses" ? "rgb(27, 110, 244)" : "lightgray",
            },
          }}
        >
          Courses
        </Button>
       <Button
        variant="contained"
        color="primary"
        onClick={() => handleButtonClick("projects")}
        sx={{
          backgroundColor: showContent === "projects" ? "rgb(14, 104, 249)" : "white",
          color: showContent === "projects" ? "white" : "black",
          marginLeft : "10px",
          border: "1px solid rgb(14, 104, 249)",
          '&:hover': {
            backgroundColor: showContent === "projects" ? "rgb(14, 104, 249)" : "lightgray",
          },
        }}
      >
        Projects
      </Button>
      </Box>
      {showContent === "courses" && <Courses />}
      {showContent === "projects" && <Projects />}
    </Box>
    </div>
  );
};

export default Start;
